import React from "react";
import { func } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Button } from "reactstrap";

import { Input } from "../../../../components/formik";
import "./searchWatchListEntriesForm.css";
import CreateWatchListEntryModal from "../create-watch-list-entry-modal/CreateWatchListEntryModal";

const SearchWatchListEntriesForm = ({ handleSubmit }) => (
  <Formik onSubmit={handleSubmit} initialValues={{ country: "" }}>
    <Form className="search-watch-list-entries-form">
      <div className="search-watch-list-entries-form-inner-box ">
        <Field
          type="text"
          name="country"
          placeholder="Country"
          component={Input}
        />
        <Button className="high-risk-countries-search" type="submit">
          Search
        </Button>
        <CreateWatchListEntryModal />
      </div>
    </Form>
  </Formik>
);

SearchWatchListEntriesForm.propTypes = {
  handleSubmit: func.isRequired,
};

export default SearchWatchListEntriesForm;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/search-watch-list-entries-form/SearchWatchListEntriesForm.jsx